/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deletePublicProjectHistoryActions, {
    deletePublicProjectHistoryTypes,
} from '../../../redux/collectData/deletePublicProjectHistory'
import getPublicProjectHistoryActions from '../../../redux/collectData/getPublicProjectHistory'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* deletePublicProjectHistorySagas({ response }) {
    try {
        const responseDelete = yield Delete(`csv/project_data/${response.id}`)
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    getPublicProjectHistoryActions.getPublicProjectHistoryRequest()
                ),
                yield put(
                    deletePublicProjectHistoryActions.deletePublicProjectHistorySuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
        } else {
            yield put(
                deletePublicProjectHistoryActions.deletePublicProjectHistoryFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(
            deletePublicProjectHistoryActions.deletePublicProjectHistoryFailure(
                error
            )
        )
    }
}

export function* deletePublicProjectHistorySaga() {
    yield takeLatest(
        deletePublicProjectHistoryTypes.DELETE_PUBLIC_PROJECT_HISTORY_REQUEST,
        deletePublicProjectHistorySagas
    )
}
